module.exports = __webpack_public_path__ + "static/media/cu.e4f897dc.svg";